import {put, takeLatest, call} from 'redux-saga/effects';
import * as orderService from "../../../services/orderService";
import {
    CANCEL_ORDER,
    CANCEL_ORDER_SUCCESS,
    CANCEL_ORDER_ERROR,
}
    from "../../actions/order";

function* cancelOrderSaga(action) {
    try {
       const data  = yield call(orderService.CancelOrder,action.payload)
        
       yield put({
        type: CANCEL_ORDER_SUCCESS,
        payload: data
    });


    } catch(error) {
        yield put({
            type: CANCEL_ORDER_ERROR, error: error.data
        });
    }
}


export function* cancelOrderSagaWatcher() {
    yield takeLatest(CANCEL_ORDER, cancelOrderSaga);
}